import { Grid } from "@mui/material";
import React from "react";
import BillsTabel from "./home/table";
import BillsHeader from "./home/header";

const Bills = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BillsHeader />
      </Grid>
      <Grid item xs={12}>
        <BillsTabel />
      </Grid>
    </Grid>
  );
};

export default Bills;
